export default {
  useMoreAddress: '使用其他地址',
  hideAddress: '收起地址',
  productInventory: '商品清单',
  tag: '标签',
  retainTag: '保留标签',
  delTag: '去除标签',
  externalPack: '外部包装',
  packDetail: '包装详情',
  postLine: '寄送路线',
  selectLine: '选择线路',
  editLine: '修改线路',
  service: '服务',
  cancelServe: '取消服务',
  previewPackage: '预演包裹',
  postCountry: '寄送国家',
  packageNo: '包裹编号',
  deliver: '寄往',
  packageDetail: '包裹详情',
  addressInfo: '地址信息',
  voWeight: '体积重',
  firstWeight: '首重',
  continueWeight: '续重',
  actWeight: '实际称重',
  packageStatus: '包裹状态',
  freightDetail: '花费信息',
  declareCurrency: '申报币种',
  selfDeclare: '自主申报',
  packageDeclarePrice: '包裹申报总价格',
  youPackageProduct: '您包裹内的商品',
  editYourDeclare: '请编辑您的申报信息',
  startDeclare: '开始申报',
  declareType: '申报种类',
  productNo: '商品编号',
  declareProductPrice: '申报商品单价',
  declareTotalPrice: '申报商品总额',
  editDeclare: '修改申报',
  declareLinePriceHint: '当前线路申报总额最低：{min} 最高：{max}',
  classMaxNumHint: '单类数量已达上限 {max}',
  addDeclareProduct: '添加申报商品',
  plsConfirmInfo: '请确认信息',
  wipePackProduct: '去除包装商品',
  foldPackProduct: '折叠包装商品',
  wipeTagProduct: '去除标签商品',
  aboutCalcWeightExplain:
    '由于当前包裹未打包，现阶段不知道包裹真实的重量，因此我们只能靠几个现有参数进行包裹重量预估，以此收取押金，待包裹打包完毕得到真实重量后进行多退少补。',
  expressInfo: '物流信息',
  deliveryMode: '配送方式',
  targetCountry: '目标国家',
  cancelPackage: '取消包裹',
  cancelPackageHint: '确认要取消此包裹吗? 取消后将无法恢复。',
  isDelPackage: '确认要永久删除包裹吗?',
  delPackageHint: '永久删除后，您将无法再查看该包裹，请谨慎操作！',
  receivedTips: '您的包裹已签收,欢迎再次使用',
  packageQuestion: '包裹寄送过程发生了问题,您可以',
  afterSale: '申请售后',
  repair: '补款',
  ucan: '你可以',
  clickAdd: '点此添加',
  addCategoryTips: '以上没有您想申报的商品名',
  noCarrierLines: '没有可运送的寄送线路',
  confirmPackageTitle: '确认收到货了吗？',
  confirmPackageTips: '为了保障您的售后权益，请收到包裹确认无误后再确认收货',
  receiptSuccess: '签收成功',
  position: '定位',
  time: '时间',
  duty: '税号',
  inputTrueDuty: '请输入正确的税号',
  serveStatusEnum: {
    1: '定制照片',
    2: '延长保管期',
    5: '视频质检',
  },
  inputCareTime: '请选择保管时间',
  holder: {
    noInputSearch: '包裹号/商品编号',
    inputEditDeclareInfo: '请编辑您的申报信息',
    packageRemark: '如果您对包裹还有其他特备要求，请在这里备注',
    yourPriceSummary: '您的价格总汇',
  },
  calcFee: '预估费用',
  realFee: '实际费用',
  declare: {
    repeatDeclare: '重复申报类型',
    addDeclareType: '请添加申报类型',
  },
  feeEnum: {
    totalAmount: '预估押金',
    deposit: '预估费用',
    overLongFee: '超长费用',
    overWeightFee: '超重费用',
    remoteFee: '偏远费用',
    feeCustoms: '物流商处理费',
    feeFuel: '燃油附加费',
    feeOperation: '操作费',
    feeService: '服务费',
    valueAddedTax: '增值税',
    insuranceService: '保费',
    incrementAmount: '增值服务费',
    lineDiscount: '线路折扣',
    discount: 'vip折扣',
    coupon: '选择优惠券',
    passwordDiscount: '优惠口令',
    orderPreDiscount: '商品折扣',
    insuranceDiscount: '保险优惠',
    incrementDiscount: '增值服务优惠',
    preVolumeCal: '预估称重',
    actDeposit: '称重后运费',
    actDepositAmount: '最终需支付',
  },
  ratePaymentEnum: {
    name: '缴税方式',
    0: '收件人缴纳',
    1: '平台GST/VAT',
    2: '个人GST/VAT',
    3: '平台IOSS',
    4: '个人IOSS',
    5: '公司GST/VAT',
    6: '物流商GST/VAT',
    7: '物流商IOSS',
    8: '免税',
  },
  bagStatusEnum: {
    0: '正常包裹',
    1: '国内退包',
    2: '国外退包',
    3: '取消包裹',
    4: '补款包裹',
  },
  packageStatusEnum: {
    0: '待处理',
    1: '处理中',
    2: '出库中',
    3: '已出库',
    4: '已打包',
    5: '已称重',
    6: '已打印运单号',
    7: '已验证',
    8: '已交接',
    9: '已发货',
    20: '确认收货',
  },
  declareEnum: {
    name: '申报方式',
    0: '模糊申报',
    1: '自主申报',
  },
  backText: '返回',
  packageInformation: '包裹信息',
  parcelNumber: '包裹状态',
  noValidRule: '申报金额不通过规则: {rule}',
  shippingAgree: 'acbuy包裹运输协议',
  haveDiscountCode: '我有折扣码',
  inputDiscountCode: '在这里输入折扣码',
  expressNo: '物流单号',
  shipping: '运费',
  taxation: '税费',
  acCare: '保险费',
  discountCode: '折扣码',
  coupon: '优惠券',
  rangeDeclare: '您的申报金额超出范围',
  noCouponData: '没有符合运费折扣条件的优惠券。',
  exchange: '兑换',
  'i18n-000001': '材质',
  'i18n-000002': '颜色',
  'i18n-000003': '型号/尺寸',
  'i18n-000004': '材质',
  'i18n-000005': '是否申报',
  'i18n-000006': '温馨提示',
  'i18n-000007': '当提交之后，我司将不对此申报信息进行修改，预清关失败后，我们仍然继续发出。',
  'i18n-000008': '1、应巴西海关要求，请详细申报品名、材质、颜色、型号 / 尺寸，总申报品名不超5条；',
  'i18n-000009': '2、因巴西小包为个人用途，多个包裹同时到达海关时会扣货，多个商品请隔开提包；',
  'i18n-000010':
    '3、建议单个包裹不超过4KG，每件商品申报不低于3USD, 针对高货值产品（游戏机、手机、平板、电脑等）尽量如实申报以免造成海关查扣；',
  'i18n-000011':
    '4、巴西当地征税标准：申报50美金以下，按照17 % ICMS + 20 % Duty计税，50美金以上，按照17 % ICMS + 60 % Duty，仅供参考；',
  'i18n-000012': '5、包裹运抵巴西后请关注短信和邮件，并及时支付税金',
  'i18n-000013': '{ num } 个',
  'i18n-000014': '品名',
  cartonWarning: '您的包裹尺寸和重量过大，建议您选择纸箱包装，降低包裹损坏风险，且有更好的压缩效果',
  'i18n-0000003': '包裹号',
  'i18n-0000004': '提交时间',
  'i18n-0000005': '预估包裹体积',
  'i18n-0000006': '预估包裹重量',
  'i18n-0000007': '预估费用',
  'i18n-0000009': '物流名称',
  'i18n-0000010': '物流单号',
  'i18n-0000011': '待支付',
  'i18n-0000017': '优惠金额',
  'i18n-0000018': '收货地址信息',
  'i18n-0000019': '申报信息',
  'i18n-0000020': '申报名称',
  'i18n-0000021': '申报金额($)',
  'i18n-0000022': '数量',
  'i18n-0000023': '小计($)',
  'i18n-0000024': '申报合计',
  'i18n-0000025': '商品信息',
  'i18n-0000026': '商品名称',
  'i18n-0000027': '重量(g)',
  'i18n-0000028': '体积(cm³)',
  'i18n-0000029': '包装细节',
  'i18n-0000033': '待退款',
  'i18n-0000034': '待补款',
  'i18n-0000035': '实际包裹体积',
  'i18n-0000036': '计费包裹重量',
  'i18n-0000037': '实际费用',
  'i18n-0000038': '实际支付',
  'i18n-0000039': '打包照片',
  'i18n-0000040': '下载包裹发票',
  'i18n-0000041': '已退余额',
  'i18n-0000042': '退款',
  'i18n-0000043': '补款',
  'i18n-0000046': '展开',
  'i18n-0000047': '收起',
  'i18n-0000048': '物流轨迹',
  'i18n-0000049': '称重信息',
  'i18n-0000050': '退款',
  'i18n-0000051': '预计72小时退款',
  samePreviewTips: '该预演包裹已提交，是否再次提交？',
  confirmSubmitTitle: '确认并继续',
  confirmSubmitText: '请确认您的收件地址:',
  confirmSubmitContent: `收货地址：{address}

重要说明：当前显示的收费重量为预估值。最终计费重量将以打包后的实际测量值为准，通常按体积重与实际重量二者中的较大值计费。若最终费用与预估存在差异，将依据“多退少补”原则处理。 `,
}
